// mc-3d-loader: watches the variant picker and swaps the media gallery for the
// colour preview while the Full Colour variant is active. Two viewer bundles
// share this loader, the container markup and the colour-select layout below:
// the 3D viewer (mc-3d-viewer.min.js, window.MC3DViewer, FAB/TIN foldables
// with custom.model_3d) and the image viewer (mc-image-viewer.min.js,
// window.MCImageViewer, WAR/SAC bundles with custom.colour_preview). The
// snippet picks one per product and names the bundle in data-viewer-src and
// its global in data-viewer-global; each exposes createViewer(container)
// resolving to {show, hide} once its first frame is ready. The bundle is
// script-injected only on first activation, so plain visits never pay for it.
// Plain script loading is deliberate: Shopify's CDN minifier transpiles
// dynamic import() in .js assets into require(), which breaks in the browser —
// do not use import() here. Mirrors the variant-detection logic of the
// colour-dropdown Custom Liquid block so both stay in lockstep.
(function () {
  var TRIGGER = 'full colour';

  function currentColor(section) {
    var checked = section.querySelector(
      'input[name^="Color"]:checked, input[name*="options[Color]"]:checked'
    );
    if (checked) return checked.value.toLowerCase();
    var sel = section.querySelector('select[name*="options[Color]"]');
    return sel ? sel.value.toLowerCase() : '';
  }

  var MOBILE_QUERY = window.matchMedia('(max-width: 749px)');

  function setup(container) {
    // A quick-add modal re-inserts this script (HTMLUpdateUtility re-creates
    // script tags), so the page's own container must not be bound twice.
    if (container.dataset.mc3dBound) return;
    container.dataset.mc3dBound = '1';
    // product-info wraps one product's markup; a quick-add modal nests a
    // second product-info inside the page's, with its own variant picker and
    // colour selects, and lookups below must stay inside the right one.
    var section = container.closest('product-info') || container.closest('.shopify-section') || document;
    var gallery = document.getElementById('MediaGallery-' + container.dataset.sectionId);
    var viewer = null;
    var loading = false;
    var failed = false;
    var optionsHome = null;

    // On mobile, relocate the colour-dropdown block (#mc-options, from the
    // Custom Liquid block) to directly below the viewer so customers don't
    // scroll between the selects and the model. The REAL node is moved (never
    // cloned — duplicate selects would double-submit line item properties);
    // a hidden placeholder marks its home slot in the product-info column.
    // The colour block's id is not section-scoped, so with a quick-add modal
    // open there can be two: take the one inside this product's markup.
    function findOptionsBox() {
      var boxes = section.querySelectorAll('#mc-options');
      var scoped = !!section.tagName && section.tagName.toLowerCase() === 'product-info';
      for (var i = 0; i < boxes.length; i++) {
        if (!scoped || boxes[i].closest('product-info') === section) return boxes[i];
      }
      return null;
    }

    function syncOptionsPlacement(active) {
      var box = findOptionsBox();
      if (!box) return;
      var shouldRelocate = active && MOBILE_QUERY.matches;
      var relocated = container.contains(box);
      if (shouldRelocate && !relocated) {
        if (!optionsHome) {
          optionsHome = document.createElement('span');
          optionsHome.hidden = true;
        }
        if (!optionsHome.parentNode) box.parentNode.insertBefore(optionsHome, box);
        layoutOptions(box);
        container.appendChild(box);
      } else if (!shouldRelocate && relocated && optionsHome && optionsHome.parentNode) {
        optionsHome.parentNode.insertBefore(box, optionsHome);
      }
    }

    // Grid placement for the colour block (applies in its home position and
    // when relocated under the viewer): label/select pairs fill rows of at
    // most 3 columns (4 colours -> 2x2, 5 -> 3+2), notes label and textarea
    // span full width below the last row. Positions are assigned inline
    // because the pair structure is flat sibling markup.
    function layoutOptions(box) {
      var labels = box.querySelectorAll(':scope > label');
      var rows = box.querySelectorAll(':scope > div');
      var count = rows.length;
      if (!count) return;
      var cols = count <= 3 ? count : count === 4 ? 2 : 3;
      box.style.setProperty('--mc-3d-cols', cols);
      for (var i = 0; i < count; i++) {
        var col = (i % cols) + 1;
        var band = Math.floor(i / cols) * 2;
        if (labels[i]) {
          labels[i].style.gridColumn = col;
          labels[i].style.gridRow = band + 1;
        }
        rows[i].style.gridColumn = col;
        rows[i].style.gridRow = band + 2;
      }
      var notesRow = Math.ceil(count / cols) * 2 + 1;
      var notesLabel = labels[count];
      var textarea = box.querySelector(':scope > textarea');
      if (notesLabel) {
        notesLabel.style.gridColumn = '1 / -1';
        notesLabel.style.gridRow = notesRow;
      }
      if (textarea) {
        textarea.style.gridColumn = '1 / -1';
        textarea.style.gridRow = notesRow + 1;
      }
    }

    // The viewer stage adopts the gallery's featured-media aspect ratio so it
    // occupies exactly the box it swaps in for — measured while the gallery
    // still has layout (before the hide class lands), re-measured each swap.
    function matchGallerySize() {
      if (!gallery) return;
      var media = gallery.querySelector('[id^="GalleryViewer-"] .product__media, .product__media');
      if (!media) return;
      var rect = media.getBoundingClientRect();
      if (rect.width > 10 && rect.height > 10) {
        var stage = container.querySelector('.mc-3d__stage');
        stage.style.aspectRatio = (rect.width / rect.height).toFixed(4);
      }
    }

    function swapIn() {
      matchGallerySize();
      // The hide class's effect is viewport-dependent (see mc-3d-viewer.css):
      // mobile hides the whole gallery, desktop hides only the big image
      // slider so the thumbnail strip stays visible below the viewer.
      if (gallery) gallery.classList.add('mc-3d-gallery-hidden');
      container.hidden = false;
      syncOptionsPlacement(true);
      viewer.show();
    }

    function swapOut() {
      syncOptionsPlacement(false);
      if (gallery) gallery.classList.remove('mc-3d-gallery-hidden');
      container.hidden = true;
      if (viewer) viewer.hide();
    }

    function isActive() {
      return currentColor(section).indexOf(TRIGGER) !== -1;
    }

    function update() {
      if (!isActive()) {
        swapOut();
        return;
      }
      if (failed) return;
      if (viewer) {
        swapIn();
        return;
      }
      if (loading) return;
      loading = true;
      loadBundle(function (api) {
        api
          .createViewer(container)
          .then(function (created) {
            viewer = created;
            loading = false;
            if (isActive()) swapIn();
          })
          .catch(fail);
      }, fail);
    }

    function fail(err) {
      // Graceful no-op: keep the normal media gallery, never retry.
      loading = false;
      failed = true;
      if (window.console && console.warn) console.warn('mc-3d: viewer unavailable', err);
    }

    function loadBundle(onReady, onError) {
      var globalName = container.dataset.viewerGlobal || 'MC3DViewer';
      if (window[globalName]) {
        onReady(window[globalName]);
        return;
      }
      var script = document.createElement('script');
      script.src = container.dataset.viewerSrc;
      script.onload = function () {
        if (window[globalName]) onReady(window[globalName]);
        else onError(new Error(globalName + ' global missing after load'));
      };
      script.onerror = function () {
        onError(new Error('failed to load ' + script.src));
      };
      document.head.appendChild(script);
    }

    // Lay out the colour block in its home position at load — the same
    // horizontal grid is used on desktop (info column) and mobile (relocated).
    var homeBox = findOptionsBox();
    if (homeBox) layoutOptions(homeBox);

    section.addEventListener('change', update);
    MOBILE_QUERY.addEventListener('change', function () {
      // Crossing the breakpoint while the viewer is active moves the colour
      // selects to (or back from) the media area; the gallery's hide class
      // is viewport-scoped in CSS, so it needs no re-toggling here.
      syncOptionsPlacement(!container.hidden);
    });

    // While the viewer is active on desktop, the big image slider is hidden,
    // so a thumbnail's normal job (driving that slider) has no visible
    // effect. Delegate thumbnail clicks to the matching slide's zoom-modal
    // opener instead — customers can still view photos full-size.
    if (gallery) {
      gallery.addEventListener('click', function (event) {
        if (container.hidden || MOBILE_QUERY.matches) return;
        var item = event.target && event.target.closest
          ? event.target.closest('.thumbnail-list__item[data-target]')
          : null;
        if (!item) return;
        var slide = document.getElementById('Slide-' + item.getAttribute('data-target'));
        var opener = slide && slide.querySelector('.product__media-toggle');
        if (opener) opener.click();
      });
    }
    update();
  }

  document.querySelectorAll('.mc-3d[data-viewer-src]').forEach(setup);
})();
